$(document).ready(function () {
	const $menu_btn_click = $('.menu > li.dropdown-click > a');
	const $parent_menu = $('.menu > li.dropdown-click');
	const $sub_menu_list = $('.menu > li.dropdown-click > ul.sub-menu');
	const $toggle_dropdown_menu_class = 'open-sub-menu';
	const $parent_menu_toggled_class = 'dropdown-toggled';
	const $hover_speed = '200';

	//sub menu button click mobile

	$menu_btn_click.on('click touch', function () {

		$(this).toggleClass($toggle_dropdown_menu_class);

		if ($(this).hasClass($toggle_dropdown_menu_class)) {
			$sub_menu_list.css({
				display: 'flex',
			});
			$sub_menu_list.slideDown($hover_speed);
			//Active state handler
			$parent_menu.addClass($parent_menu_toggled_class);
		} else {
			$sub_menu_list.slideUp($hover_speed);
			//Active state handler
			$parent_menu.removeClass($parent_menu_toggled_class);
		}
	});

	//sub menu button hover accessibility
	$menu_btn_click.on('keydown', function (e) {
		if (e.keyCode === 27) {
			// ESC
			$sub_menu_list.slideUp($hover_speed);
		}
	});
});
